var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCaptain(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M6.24512 2H9.75488C10.4905 2 11.0447 2.00019 11.4844 2.03613C11.9286 2.07222 12.2586 2.14489 12.5449 2.29004C13.0463 2.54596 13.4537 2.95435 13.709 3.45605V3.45703C13.8542 3.74126 13.9277 4.07083 13.9639 4.51562C13.9998 4.95527 14 5.50947 14 6.24512V9.75488C14 10.3069 13.9997 10.757 13.9844 11.1328L13.9639 11.4844C13.9278 11.9288 13.8543 12.2585 13.709 12.5449C13.4532 13.0461 13.0454 13.4536 12.5439 13.709C12.3295 13.8181 12.091 13.8862 11.7979 13.9287L11.4844 13.9639C11.0447 13.9998 10.4905 14 9.75488 14H6.24512C5.69307 14 5.24301 13.9997 4.86719 13.9844L4.51562 13.9639L4.20215 13.9287C3.95775 13.8933 3.7513 13.8404 3.56543 13.7607L3.45605 13.71C3.01688 13.4862 2.64977 13.1455 2.39355 12.7275L2.29102 12.5439C2.14552 12.258 2.07222 11.9286 2.03613 11.4844C2.00019 11.0447 2 10.4905 2 9.75488V6.24512L2.00488 5.26855C2.00947 4.98346 2.01818 4.73529 2.03613 4.51562C2.06772 4.12682 2.1277 3.82574 2.23926 3.56543L2.29004 3.45605C2.54584 2.9543 2.95417 2.54656 3.45605 2.29102H3.45703C3.74126 2.1458 4.07083 2.07226 4.51562 2.03613C4.73529 2.01818 4.98346 2.00947 5.26855 2.00488L6.24512 2Z",
    stroke: "#121212"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCaptain);
export default __webpack_public_path__ + "static/media/captain.ff7e4c8060a4e8436114ae6d2e2fe7db.svg";
export { ForwardRef as ReactComponent };